/* William Painter: Build Your Own Pair lens finish names as shoppers see them.
 * The ONE default map, shared by the lens builder (assets/rx-builder.js) and the cart pair card
 * (assets/rx-cart-group.js). Keys are the catalog names (the Lens Finish product's Finish option
 * values); the catalog, line properties and orders keep those. The builder section's
 * finish_display_names setting can override entries on the builder page only.
 */
(function (w) {
  'use strict';
  if (w.WPByopFinishNames) return;
  var map = {
    'Solid Tint': 'Solid Tint Non Polarized',
    'Gradient Tint': 'Gradient Tint Non Polarized',
    'Solid Tint Polarized': 'Solid Tint Polarized',
    'Gradient Tint Polarized': 'Gradient Tint Polarized',
    'Solid Mirror': 'Non Polarized Mirror',
    'Polarized Mirror': 'Polarized Mirror'
  };
  w.WPByopFinishNames = {
    map: map,
    // Display name for a catalog finish name; unknown or empty names come back unchanged.
    name: function (n, overrides) {
      var o = overrides || {};
      return (n && (o[n] || map[n])) || n;
    }
  };
})(window);
